import { createContext, ReactNode, useContext } from "react";

import { useFilterLocation } from "./filter-location.hook";

const FilterLocationContext = createContext(
  {} as ReturnType<typeof useFilterLocation>
);
export function useFilterLocationContext() {
  return useContext(FilterLocationContext);
}

interface FilterLocationProviderProps {
  children: ReactNode;
}
export function FilterLocationProvider({
  children,
}: FilterLocationProviderProps) {
  return (
    <FilterLocationContext.Provider value={useFilterLocation()}>
      {children}
    </FilterLocationContext.Provider>
  );
}